import { ButtonLink } from '@asgard/ui-library';
import { faShareSquare } from '@fortawesome/pro-light-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from 'components/layout/Page';
import { Button } from 'components/shared/Button';
import ShareModal from 'components/shared/ShareModal';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Element } from 'react-scroll';
import ServiceEventTracking from 'services/service.event-tracking';
import { LOGO_MANFRED_WHITE } from 'utils/logos';
import Benefits from './components/benefits/Benefits';
import Companies from './components/companies/Companies';
import Gender from './components/gender/Gender';
import Intro from './components/intro/Intro';
import Methodology from './components/methodology/Methodology';
import Talent from './components/talent/Talent';
import { useMandecar } from './Mandecar.hook';
import { StyledFooter, StyledFooterActions } from './Mandecar.styled';

type MandecarProps = {
  manfreditesCount: number;
};

const MandecarComponent: React.FC<MandecarProps> = ({ manfreditesCount }) => {
  // Hooks.
  // ---------------------------------------------------------------------------
  const { onClickCTA, urlCTA } = useMandecar();

  const { locale } = useRouter();

  const { t } = useI18n('developer-career-report-2023');

  const [isShareModalOpened, setIsShareModalOpened] = useState(false);

  // Render.
  // ---------------------------------------------------------------------------
  return (
    <Page hasScrollTop>
      <Intro manfreditesCount={manfreditesCount} />
      <Element name="talent" id="talent">
        <Talent />
      </Element>
      <Element name="benefits" id="benefits">
        <Benefits />
      </Element>
      <Element name="companies" id="companies">
        <Companies />
      </Element>
      <Element name="gender" id="gender">
        <Gender />
      </Element>
      <Element name="methodology" id="methodology">
        <Methodology />
      </Element>

      <StyledFooter>
        <img
          src={LOGO_MANFRED_WHITE}
          alt="Manfred logo"
          width="275"
          height="50"
        />
        <span>{t('mandecar23.footer_tagline')}</span>
        <StyledFooterActions>
          <Button
            variant="secondaryInverse"
            type="button"
            onClick={() => {
              ServiceEventTracking.trackLandingCtaClicked('mandecar-compartir');
              setIsShareModalOpened(true);
            }}
          >
            <FontAwesomeIcon icon={faShareSquare} />
            <span>{t('mandecar23.footer-share')}</span>
          </Button>

          <ButtonLink
            href={urlCTA}
            schema="brand2"
            variant="hard"
            startIcon={faCheckCircle}
            label={t('mandecar23.footer_cta')}
            onClick={(event) => onClickCTA(event)}
          />
        </StyledFooterActions>
      </StyledFooter>

      {isShareModalOpened && (
        <ShareModal
          isOpened={isShareModalOpened}
          close={() => setIsShareModalOpened(false)}
          url="https://mnfrd.co/48fCaHM"
          emailSubject={t('mandecar23.share-modal.email-subject')}
          twitterMessage={t('mandecar23.share-modal.text')}
          telegramMessage={t('mandecar23.share-modal.text')}
          whatsappMessage={t('mandecar23.share-modal.text')}
          emailMessage={t('mandecar23.share-modal.email-text')}
        />
      )}
    </Page>
  );
};

export default MandecarComponent;
